export const RECORD_MENTION_DEBOUNCE_MS = 2000;
export const MENTION_SNIPPET_MAX_LENGTH = 180;
export const MENTION_ID_PREFIX = "Mention-";
